<template>
  <div class="container">
    <b-card header-tag="header">
      <template #header>
        <b-row align-h="between" align-v="center">
          <h4 class="card-tittle">LIQUIDACIÓN</h4>
          <b-button variant="dark" @click="back()">Volver </b-button>
        </b-row>
      </template>

      <div v-if="isBusy" class="text-center text-danger space">
        <b-spinner class="align-middle"></b-spinner>
      </div>
      
      <template v-if="!isBusy">
        <b-row align-h="between" align-v="center" class="contentRow">
          <template v-if="data">         

            <!-- INICIO PRIMERA ROW -->
            <b-row align-h="between" align-v="center" class="mainRow">
              <b-col cols="3" class="redCol alto260"> DETALLE DE LIQUIDACIÓN </b-col>
              <b-col cols="9">
                <b-row class="text-center" align-v="center">

                  <b-col cols="4">
                    <p>
                      RUT Facturación:
                      <b>{{
                        data.rutFacturacion
                          ? data.rutFacturacion
                          : " No especificado"
                      }}</b>
                    </p>            
                    <p>
                      Fecha:
                      <b>{{
                        data.fechaLiquidacion ? formatFecha(data.fechaLiquidacion) : "No especificada"
                      }}</b>
                    </p>
                  </b-col>

                  <b-col cols="2"/>

                  <b-col cols="4" offset="-2" id="altoLinea">
                    <b-row>
                      <b-col cols="6" id="desc">
                        <p>Tarifa:</p>
                        <p>Opcionales:</p>
                        <p>Descuentos:</p>
                        <hr>
                        <p><b>Sub total:</b></p>
                        <p>Impuestos:</p>
                        <hr>
                        <p><b>Total Arriendo:</b></p>
                      </b-col>
                      <b-col cols="6" id="monto">
                        <p>
                          <b>
                            {{data.subTotalTarifa
                              ? "$ " + data.subTotalTarifa
                              : "No especificado"}}
                          </b>
                        </p>
                        <p>
                          <b>
                            {{data.subTotalOpcionales 
                            ? "$ " + data.subTotalOpcionales 
                            : "No especificado"}}
                          </b>
                        </p>
                        <p>
                          <b>
                            {{data.subTotalDescuento 
                            ? "$ " + data.subTotalDescuento 
                            : "$ 0"}}
                          </b>
                        </p>
                        <hr>
                        <p>
                          <b>
                            {{data.subTotalArriendo 
                            ? "$ " + data.subTotalArriendo 
                            : "No especificado"}}
                          </b>
                        </p>
                        <p>
                          <b>
                            {{data.impuesto 
                            ? "$ " + data.impuesto 
                            : "No especificado"}}
                          </b>
                        </p>
                        <hr>
                        <p>
                          <b>
                            {{data.totalArriendo 
                            ? "$ " + data.totalArriendo 
                            : "No especificado"}}
                          </b>
                        </p>
                      </b-col>
                    </b-row>                    
                  </b-col>

                </b-row>
                
              </b-col>
            </b-row>
            <!-- INICIO SEGUNDA ROW -->
            <b-row align-h="between" align-v="center" class="mainRow">
              
              <div class="table-responsive mb-0 mt-3">
                <b-table
                  thead-tr-class="titleTable"
                  :items="data.liquidacionDetalle"
                  :fields="fields"
                  responsive="sm"
                  :striped="true"
                  :bordered="true"
                >
                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->
                </b-table>
              </div>

            </b-row>

          </template>
          <template v-else>
            <h3 class="text-center">No se encontró el detalle</h3>
          </template>
        </b-row>
      </template>
      
    </b-card>
    </div>
</template>

<script>
import axios from "@/axios";
import moment from "moment";
export default {
  data() {
    return {
      data: [],
      isBusy: false,
      fields: [
        {
          key: "concepto",
          label: "Concepto",
          sortable: false,
        },
        {
          key: "valorTotal",
          label: "Total",
          sortable: false,
        },
      ]
    };
  },
  beforeMount() {
    this.getDetail();
  },
  methods: {
    back() {
      history.back();
    },
    getDetail() {
      this.isBusy = true;
      axios
        .get(`GetLiquidacionByNumero/${this.$store.getters["hideValue/detailId"]}/${this.$route.params.contrato}`)
        .then((detalle) => {
          this.isBusy = false;
          this.data = detalle.data;
        })
        .catch(() => {
          this.$bvToast.toast(
            this.$t("lease.request.error.message").toString(),
            {
              title: this.$t("lease.request.error.nonFound").toString(),
              variant: "danger",
              solid: true,
            }
          );
          this.isBusy = false;
        });
    },
    formatFecha(fecha){
      return moment(fecha).format("DD-MM-YYYY") + " " + moment(fecha).format("HH:mm:ss")
    }
  },
};
</script>

<style scoped>
.mainRow {
  width: 100%;
  padding-left: 1em;
  padding-bottom: 0.2em;
}
.redCol {
  background-color: #e2231a;
  color: white;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-items: center;
  font-size: 1rem;
  font: 200;
  text-align: center;
}
.redRow {
  background-color: #e2231a;
  color: white;
  padding-left: 1em;
  padding-right: 1em;
  margin-bottom: 3em;  
}
.card {
  width: 90%;
  margin-left: 5%;
  margin-top: 24px;  
  text-align: center;
}
.card-tittle {
  font-size: 1.5rem;
  padding: 1rem;
  color: white;
}
.colImg {
  text-align: center;
}
.card-header {
  background-color: #e2231a;
}
img{
  height: 200px;
}
.alto260{
  height: 260px !important;
}
#altoLinea{
  line-height: 9px;
}
#desc{
  text-align: right;
}
#monto{
  text-align: left;
}
</style>